export const Colors = {
    primary: "#1F3BE5",
    accent: "#3333cc",
    white: "#FFFFFF",
    black: "#000000",

    greyLight: "#F0F1F5",
    greyMed: "#D8DAE3",
    greyDark: "#6C6E79",

    green: "#3DA260",
    red: "#E85A6C",
    yellow: "#FFB100",
    yellowDark: "#EFA600",
    purple: "#7658F4",
    purpleDark: "#674ECE",
    greenDark: "#348C52",
    brown: "#D17428",
    info: "#51a6ca",

    shadow: "0 6px 15px rgba(0 0 0 / 0.1)",
    shadowBig: "0 6px 30px rgba(0 0 0 / 0.2)",
};

export const boards = {
    avr4809: {
        signature: Buffer.from([0x1e, 0x96, 0x51]),
        pageSize: 128,
        timeout: 400,
        baudRate: 115200,
        use_8_bit_addresseses: true,
    },
    lgt8f328p: {
        signature: Buffer.from([0x1e, 0x95, 0x0f]),
        pageSize: 128,
        timeout: 400,
        baudRate: 57600,
    },
    nanoOldBootloader: {
        signature: Buffer.from([0x1e, 0x95, 0x0f]),
        pageSize: 128,
        timeout: 400,
        baudRate: 57600,
    },
    nano: {
        signature: Buffer.from([0x1e, 0x95, 0x0f]),
        pageSize: 128,
        timeout: 400,
        baudRate: 115200,
    },
    uno: {
        signature: Buffer.from([0x1e, 0x95, 0x0f]),
        pageSize: 128,
        timeout: 400,
        baudRate: 115200,
    },
    proMini: {
        signature: Buffer.from([0x1e, 0x95, 0x0f]),
        pageSize: 128,
        timeout: 400,
        baudRate: 115200,
    },
};

export const NotificationMessages = {
    auth: {
        authFailed: "Invalid email or password provided.",
        invalidKey: "Invalid key provided!",
        usedKey: "This key has already been used!",
        activationSuccess: "Your account has been successfully activated.",
        userExists: "A user with this email already exists!",
        userDoesNotExists: "A user with this email does not exist!",
        activationEmailSent: "An activation link has been sent to your email.",
        resetPasswordEmailSent:
            "A reset password link has been sent to your email.",
        passwordResetSuccess:
            "Your password has been reset. You will be redirected to the sign in page shortly...",
        websocketFailed:
            "An unexpected Error has occurred with your websocket connection",
    },
    blockly: {
        invalidXml:
            "Invalid XML format. Please contact Resolute support for assistance.",
        emptyXml:
            "The current program is empty. Please contact Resolute support for assistance.",
        imported: "Block program successfully imported.",
        noBlocks: "Add blocks to the workspace to start the simulation",
    },
};

export const MetaDescriptions = {
    mainWorkspace: `${process.env.REACT_APP_NAME} is a platform for block-based programming, providing an intuitive environment for children learning coding and robotics`,
};
